import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const GraphTotalSavings = ({ data = [], title }) => {
  if (data.length < 1 || data.every((month) => month.Balance == NaN)) {
    return (
      <p className="text-center">
        <br />
        <br />
        Earn some money to see how your balance changes over time!
        <br />
        <br />
        <br />
        <br />
      </p>
    );
  }

  //calculate the max and min values for the y axis on graph
  let minY = Math.min(0, Math.min(...data.map((d) => d.Balance)));
  minY = Math.floor(minY / 10) * 10;
  let maxY = Math.max(...data.map((d) => d.Balance));
  
  // make sure maxY is at least 0
  maxY = Math.max(maxY, 0);
  maxY = Math.ceil(maxY / 10) * 10 + 10;
  let interval = Math.ceil(maxY / 5 / 10) * 10;
  const ticks = [];
  for (let i = minY; i <= maxY; i += interval) {
    ticks.push(i);
  }
  if (maxY - ticks.at(-1) < interval / 3) {
    ticks.pop();
  }
  ticks.push(maxY);

  return (
    <div className="w-full h-auto p-4 rounded-2xl shadow-md centerTheMenuButtons">
      {title && (
        <h2
          className="text-xl font-semibold mb-4"
          style={{ overflow: "visible", paddingBottom: "15px" }}
        >
          {title}
        </h2>
      )}

      <ResponsiveContainer width="70%" height={400}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="Month"
            angle={45} // Rotate the labels by 55 degrees
            textAnchor="start" // Align text starting from the left side
            padding={{ right: 50 }}
          />
          <YAxis
            domain={[minY, maxY]}
            tickCount={6}
            ticks={ticks}
            interval={"preserveStartEnd"}
            label={{
              value: "Dollars", // Set the Y-axis label here
              angle: -90, // Rotate label to make it vertical
              position: "insideLeft", // Position the label inside the chart area
              style: {
                fontSize: "18px", // Increase font size here
                fontWeight: "bold", // Optional, if you want to make the text bold
              },
              dx: -25,
              dy: 30,
            }}
          />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="Balance"
            stroke="#8884d8"
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GraphTotalSavings;
